import { formatCpfCnpj } from "@/utils/format";
import { Column } from "./DataTable";

const valorDoCampo = (field: string, item: any): any =>
  field.split('.').reduce((v, f) => (v === undefined || v === null ? undefined : v[f]), item);

export const texto = (col: Column, item: any): string => {
  if (col.exportValue) return String(col.exportValue(item) ?? '');
  const valor = valorDoCampo(col.field, item);
  if (valor === undefined || valor === null) return '';
  if (col.type === 'DATE') return new Date(`${String(valor).slice(0, 10)}T00:00:00`).toLocaleDateString('pt-BR');
  if (col.type === 'CURRENCY' || col.type === 'NUMBER') return Number(valor).toLocaleString('pt-BR', { useGrouping: false });
  if (col.type === 'CPF_CNPJ') return formatCpfCnpj(valor);
  if (col.type === 'BOOLEAN') return valor ? 'Sim' : 'Não';
  return String(valor);
}

const celula = (valor: string) => /[";\n]/.test(valor) ? `"${valor.replace(/"/g, '""')}"` : valor;

// CSV separado por ";" com BOM, para abrir direto no Excel em português
// Colunas CUSTOM só entram quando têm exportValue
export const colunasExportaveis = (columns: Column[]) =>
  columns.filter(col => col.label && col.field !== 'id' && (col.type !== 'CUSTOM' || col.exportValue));

export const exportarCsv = (arquivo: string, columns: Column[], itens: any[]) => {
  const colunas = colunasExportaveis(columns);
  const linhas = [colunas.map(col => col.label!), ...itens.map(item => colunas.map(col => texto(col, item)))];
  const blob = new Blob(['﻿' + linhas.map(l => l.map(celula).join(';')).join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${arquivo}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
